import { useState } from 'react';
import { ArrowUpRight, Play } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function ProductVideo() {
    const { t, i18n } = useTranslation();
    const [started, setStarted] = useState(false);
    const [failed, setFailed] = useState(false);
    const language = i18n.resolvedLanguage?.startsWith('es') ? 'es' : 'en';
    return (
        <section className="landing-section landing-video-section" aria-labelledby="video-title">
            <div className="landing-container landing-video-grid">
                <div className="landing-video-frame">
                    {started && !failed ? <video
                        className="landing-video"
                        src="/videos/parentscheck-how-it-works.mp4"
                        poster="/images/parentscheck-video-poster.jpg"
                        width="1280" height="720" autoPlay muted playsInline controls preload="none"
                        aria-label={t('video.ariaLabel')} onError={() => setFailed(true)}
                    >
                        <track key={language} kind="captions" src={`/videos/walkthrough-${language}.vtt`} srcLang={language} label={language === 'es' ? 'Español' : 'English'} default />
                        {t('video.fallback')}
                    </video> : <button className="landing-video-play" onClick={() => { setFailed(false); setStarted(true); }} aria-label={t('video.play')}>
                        <img src="/images/parentscheck-video-poster.jpg" width="1280" height="720" loading="lazy" alt="" />
                        <span className="landing-video-play-circle"><Play size={24} fill="currentColor" aria-hidden="true" /></span>
                        <span className="landing-video-play-label">{t(failed ? 'video.retry' : 'video.play')}</span>
                    </button>}
                </div>
                <div className="landing-section-heading">
                    <p className="landing-eyebrow">{t('video.badge')}</p>
                    <h2 id="video-title">{t('video.title')}</h2>
                    <p>{t('video.subtitle')}</p>
                    <a href="#how-it-works" className="landing-text-link">{t('video.textAlternative')}<ArrowUpRight size={16} aria-hidden="true" /></a>
                    <p className="landing-video-caption">{t('video.caption')}</p>
                </div>
            </div>
        </section>
    );
}
